module.exports = __webpack_public_path__ + "img/newEmpty.2edeb0c4.png";